let src = document.querySelector('[src*="bundle"]').getAttribute("src");
__webpack_public_path__ = src.substr(0, src.lastIndexOf("/") + 1);

require('babel-polyfill');

let $ = window.jQuery = window.$ = require('jquery');

// let js = require.context("./js", true, /^(.*\.(js$))[^.]*$/im);
// js.keys().forEach(js);

require('./js/modules/mapInit')();
require('./js/modules/menuInit')();
require('./js/modules/common');

let initCustomWidgets = window.initCustomWidgets = function () {
    require('./js/modules/snippetInit')();
};

$(initCustomWidgets);

require('./styles-entry');


// WEBPACK FOOTER //
// ./src/entry.js